/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useState } from 'react';
import { Divider, Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { AUTH_STRINGS } from '../../../../../constants/strings';
import FxMaterialSelect from '../../../../Input/FxSelect/FxMaterialSelect';
import FxCard from '../../../../Container/FxCard';
import FxCardBody from '../../../../Container/FxCardBody';
import FxCardFooter from '../../../../Container/FxCardFooter';
import { FxTextEdit } from '../../../../Input/FxText/FxTextEdit';
import FxLabelView from '../../../../Input/FxLabel/FxLabelView';
import { FxButton } from '../../../../Action/FxButton';
import usa_state from '../../../../Utils/usa_states.json'
import {
  ageLimit,
  deleteUnwantedRequest,
  handleKeyDownChange,
  handleZipChange,
  handleAddressChange,
  setZipValidationOptions,
  setPhoneValidationOptions,
  convertToPhoneRequestFormat,
  convertToPhoneDisplayFormat,
  setAddressLine1Validation,
  setSsnValidationOptions,
  setItinValidationOptions,
  ShowInfoToolTip,
  handleFieldChange,
  handleDateValidation,
  handleEmailChange,
  setCityValidation,
  fetchDataFromState,
  isNullOrUndefined,
  updateComponentData,
  sortByAuthSignatoryFirst,
  secondaryIdentificationIdValidation,
    handleSecIdChange,
    secondaryIDTypeData,
} from '../../../../Utils/CommonBaseClass';
import issuance_countries from '../../../../../libs/utils/country/country.json'
import { FxDateEdit } from '../../../../Input/FxDate/FxDateEdit';
import FxPhoneEdit from '../../../../Input/FxPhone/FxPhoneEdit';
import { FxTextEditSSN } from '../../../../Input/FxSSN/FxTextEditSSN';
import { getKey } from '../../../../../libs/utils/storageManager';
import HttpClient from '../../../../../libs/utils/httpClient';
import FxRadioEdit from '../../../../Input/FxRadio/FxRadioEdit';
import { FieldErrorMessageRender } from '../../Common/FieldErrorMessageRender';
import { useDispatch, useSelector } from 'react-redux';
import { saveNodeData, savePerFieldData } from '../../../../../libs/utils/autoSaveField';
import { useIsMobileScreen } from '../../../../../libs/utils/utils';

const httpClient = HttpClient.getClient()
//component used to edit business owner

export const BusinessOwnerEdit: React.FC<any> = React.memo(
    (props) => {
        const { register, formState: { errors, isSubmitting,isValid }, handleSubmit, setValue, control, clearErrors, setError, watch, getValues } = useForm({mode: 'onChange',reValidateMode:'onChange'});
         const [secondaryIdType, setSecondaryIdType] = useState('');
        const [checkBoxValue, setCheckBoxValues] = useState<any>({ authorized: false, creditReport: false })
        const [businessOwnerDetails, setBusinessOwnerDetails] = useState<any>();
        const defaultTaxIdentifier = businessOwnerDetails?.itin  ? 'itin' : 'ssn';
        const taxIdentifier = watch('taxIdentifier') || defaultTaxIdentifier;
        const isMobileScreen = useIsMobileScreen();
        const dispatch = useDispatch();
        
        const taxIdentifierData = [
            { label: "SSN", value: "ssn" },
            { label: "ITIN", value: "itin" },
        ];
        const invitationType = getKey('invitationType')

        
        /**
        * Function to be called before loading the component
        */
        useEffect(() => {
            if (props.data) {
                setBusinessOwnerDetails(props?.data);
                setSecondaryIdType(props?.data?.secondaryIdentificationType)
                setCheckBoxValues({ authorized: props?.data?.authSignatory === undefined ? false : props?.data?.authSignatory?.[0] === 'authorized' ? true : props?.data?.authSignatory ? props?.data?.authSignatory : false, creditReport: props?.data?.creditReport === undefined ? 'no' : props?.data?.creditReport === 'creditReport' ? true : props?.data?.creditReport ? props?.data?.creditReport : false })
            }
        }, [props?.data]);

        const isAuthUser = props?.data?.authSignatory === true || props?.data?.authSignatory === 'yes' || props?.data?.authSignatory === 'true' ? true : false
        if (getKey('email') && props?.data?.email === getKey('email')) {
            setValue('email', getKey('email'))
        }

        /**
         * This useEffect basically checks if the BO being editted
         * is an Auth user, then it automatically saves FirstName, LastName, actAsAuthorizedSignatory &
         * email to the /onboardingFormData API
         */
        useEffect(() => {
            if(props?.index === 0 && isAuthUser){
                
                let req = {
                    "business.beneficialOwner[0].firstName": businessOwnerDetails?.firstName,
                    "business.beneficialOwner[0].lastName": businessOwnerDetails?.lastName,
                    "business.beneficialOwner[0].email": props?.data?.email,
                    "business.beneficialOwner[0].actAsAuthorizedSignatory": true,
                    "business.beneficialOwner[0].isUSCitizen": businessOwnerDetails?.usCitizen,
                    ...(invitationType === "SMS" && {
                        "business.beneficialOwner[0].mobilePhone": getKey('phone')
                      })
                }
                savePerFieldData(req, '/onboardingFormData');
            }
        }, [
            props?.index,
            isAuthUser,
            businessOwnerDetails?.firstName,
            businessOwnerDetails?.lastName,
            getKey,
            savePerFieldData
        ]);

        useEffect(() => {
            // Reset the value of the selected taxIdentifier (SSN or ITIN) field when the taxIdentifier changes
            setValue(taxIdentifier, props?.data?.itin || props?.data?.ssn);
            
            // Clear any errors for the field that is not selected
            clearErrors(taxIdentifier === 'ssn' ? 'itin' : 'ssn');
        }, [taxIdentifier]);

        const usCitizenDropdown:any =[
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' },
        ]

        //Set Validation condition for Ownership Percentage
        const authSignDate: any = useMemo(() => {
            let requiredField: boolean;
            if (checkBoxValue?.authorized === true && (props.businessDetails?.['businessCategory'] === 'GOVERNMENT_ORGANISATION' || props.businessDetails?.['businessCategory'] === 'NON_PROFIT' || props.businessDetails?.['businessCategory'] === 'TAX_EXEMPTION' || props.businessDetails?.['businessCategory'] === 'LLC' || props.businessDetails?.['businessCategory'] === 'LLP' || props.businessDetails?.['businessCategory'] === 'S-CORP ' || props.businessDetails?.['businessCategory'] === 'C-CORP')) {
                delete errors['ownerShipPercentage']
                requiredField = true
            }
            else {
                requiredField = false
            }
            return requiredField
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [checkBoxValue])

        // Email validation constant
        const setEmailValidationOptions = {
            required: true,
            maxLength: 250,
            pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,40}$/i,
                message: AUTH_STRINGS.ERRORS.EMAIL_INVALID_REGEXP,
            },
        };

        // Ownership percentage validation constant
        const setOwnerShipPercentageRule = {
            required: authSignDate === true ? false : true,
            min: 0,
            max: 100
        };

        
        /**
         * Handles changes for of secondary identification type field.
         *
         * Specifically, if the changed field is 'secondaryIdentificationType',
         * it updates the state and clears any validation errors for the
         * 'secondaryIdentificationId' field.
         *
         * Regardless of the field, it saves the updated data using `saveNodeData`.
         *
         * @param e - The event object from the input field.
         * @param fieldName - The name of the field being changed.
         */
        const handleChange = (e: any, fieldName: string) => {
            if(fieldName === 'secondaryIdentificationType'){
                setSecondaryIdType(e.target.value)
                clearErrors('secondaryIdentificationId')
            }
            saveNodeData('ownership-info-page', fieldName, e, setValue, getValues,  dispatch, businessState, props?.index);
        }
       
        // Method handles the submit for edit beneficial owner form
       async function onSubmit(data: any) {
            if (taxIdentifier === 'itin') {
                // If 'itin' exists in form data, keep it, otherwise, use 'itin' from businessOwnerDetails
                data.itin = data?.itin || businessOwnerDetails?.itin;

                // Remove 'ssn' field from the data since ITIN is being used
                delete data.ssn;
            } else {
                // If the tax identifier is not 'itin', check for 'ssn'
                // If 'ssn' exists in form data, keep it, otherwise, use 'ssn' from businessOwnerDetails
                data.ssn = data?.ssn || businessOwnerDetails?.ssn;

                // Remove 'itin' field from the data since SSN is being used
                delete data.itin;
            }
            delete data.taxIdentifier;

            // For the Auth User - Auto Save usecase, these details are already filled up, so sending them manually
            if(isNullOrUndefined(data.firstName)){
                data['firstName'] = getValues('firstName')
            }
            if(isNullOrUndefined(data.lastName)){
                data['lastName'] = getValues('lastName')
            }
            
            const beneficial: any = await callCustomerAPI()
            if (beneficial && beneficial.business && beneficial.business.beneficialOwner) {
                let updateBeneficialOwner: any = beneficial.business.beneficialOwner.find((item: any, index: any) => index === props?.index);
                if (updateBeneficialOwner) {
                    data.id = updateBeneficialOwner.id;
                }
            }
            const req: any = { ...data };
            if(data['mobilePhone'] === ""){
                setError("mobilePhone", {
                    type: "required",
                    message: "mobile phone is required.",
                  });
                return;
            }
           if(data['id'] === ''){
                delete data['id'];
                delete req['id'];
            }
            if (data['dob']) {
                req['dob'] = moment(data['dob']).format('MM/DD/YYYY');
            }
            const address :any = {
                "addressLine1": data['addressLine1'],
                "addressLine2": data['addressLine2'],
                "city": data['city'],
                "state": data['state'],
                "zip": data['zip'],
                "isPrimary": true,
            }
            if(data['address_id']){
                address['id'] = data['address_id'];
            }
            req['mailingAddress'] = [address]
            req['businessDetails'] = {
                'ownershipPercentage': data['ownerShipPercentage'],
                'title': data['jobtitle']
            }
            
            req['mobilePhone'] = convertToPhoneRequestFormat(req.mobilePhone) 
            if(req['mobilePhone'] === ""){
                delete req['mobilePhone'];
            }
            req['isUSCitizen'] = data['usCitizen']==='yes' ? true : false
            req['actAsAuthorizedSignatory'] = checkBoxValue.authorized
            if(req['actAsAuthorizedSignatory'] === 'yes'){
                req['actAsAuthorizedSignatory'] = true;
            }
            req['actAsAuthorizedSignatory'] = checkBoxValue.authorized

            if (!req['businessDetails']['ownershipPercentage']) {
                delete req['businessDetails']['ownershipPercentage'];
            }
            // Set secondary identification object for request, based on type: use state for driver's license, country for others (default to 'US' for alien card)
            req["secondaryIdentification"] = data['secondaryIdentificationType'] === 'DRIVER_LICENSE' ? {
                'type': data['secondaryIdentificationType'],
                'id': data['secondaryIdentificationId'],
                'stateOfIssuance': data['secondaryIdentificationIssuanceState']
            } : {
                'type': data['secondaryIdentificationType'],
                'id': data['secondaryIdentificationId'],
                'countryOfIssuance': data['secondaryIdentificationType'] === 'ALIEN_REGISTRATION_CARD' ? 'US' : data['secondaryIdentificationIssuance']
            }
            if (data) {
                data['authSignatory'] = checkBoxValue.authorized
                data['creditReport'] = checkBoxValue.creditReport
            }

            const unwantedRequestArray = ['state', 'addressLine1', 'city', 'zip', 'addressLine2', 'jobtitle', 'authSignatory', 'ownerShipPercentage', 'creditReport', 'secondaryIdentificationType', 'secondaryIdentificationId', 'secondaryIdentificationIssuance', 'secondaryIdentificationIssuanceState', ,'usCitizen','mobilePhone-select'];
            deleteUnwantedRequest(req, unwantedRequestArray)

            const dataCopy = {...businessState?.data};
            dataCopy['beneficialOwnerData'] = [data];
            dataCopy['beneficialOwnerReq'] = [req];
            updateComponentData(dispatch, 'customer-kyc-data', { ...dataCopy  })

           if (props.onSubmit) {
                props.onSubmit(data, req, 'edit', props?.index, (status: boolean)=>{
                })
            }
            if (props?.cancel) {
                props.cancel()
            }
        }
        /**
              * Call the Customer API to get customer details
              * @returns 
              */
        async function callCustomerAPI() {
            const response = await httpClient.get('/customer/id/' + getKey('customerId'))
            return response?.data;
        }
        // Method handles the click operation for going back to business owner list screen
        const handleGoBackClick = () => {
            if (props?.cancel) {
                props.cancel()
            }
        }

        /**
         * Data for the Set As Auth Signatory radio button
         */
        const setAsAuthSignatoryRadioButtonData=[
            { label: 'Yes', value: "yes" },
            { label: 'No', value: "no" },
        ]
      
        /**
         * Method handles the Set As Auth Signatory radio button change event
         * @param event : event parameter
         */
        const handleSetAsAuthSignatoryRadioButtonChange = (event: any) => {
            setCheckBoxValues({ authorized: event.target.value === 'yes' ? true : false, creditReport: checkBoxValue?.creditReport === undefined ? false : checkBoxValue?.creditReport });
            saveNodeData('ownership-info-page', 'authSignatory', event, setValue, getValues,  dispatch, businessState, props?.index);
        }
        /**
         * Error messages for Date of Birth (DOB) validation:
         * - futureDate: Error if the DOB is a future date (not allowed)
         * - maxDate: Error if the DOB indicates the user is less than 18 years old
         * - minDate: (optional) Error if the DOB is before a very old date (not needed here)
         */ 
        const dobErrorMsg={
            futureDate:AUTH_STRINGS.ERRORS.AUTH_SIGNATORY_FUTURE,
            maxDate:AUTH_STRINGS.ERRORS.AUTH_SIGNATORY_LESS_THAN_18,
            minDate:""
           }
        /**
         * Error messages for Date of Birth (DOB) Beneficial Owner validation:
         * - futureDate: Error if the DOB is a future date (not allowed)
         * - maxDate: Error if the DOB indicates the user is less than 18 years old
         */ 
           const dobErrorBenfical={
            futureDate:AUTH_STRINGS.ERRORS.BENIFICIAL_OWNER_FUTURE,
            maxDate:AUTH_STRINGS.ERRORS.BENIFICIAL_OWNER_LESS_THAN_18,
           }
        /**
         * Error messages for Date of Birth (DOB) Authorized Signatory validation:
         * - futureDate: Error if the DOB is a future date (not allowed)
         * - maxDate: Error if the DOB indicates the user is less than 18 years old
         */ 
           const dobError = {
            futureDate: watch('authSignatory')==='yes' ? dobErrorMsg.futureDate : dobErrorBenfical.futureDate,
            maxDate: watch('authSignatory')==='yes' ? dobErrorMsg.maxDate : dobErrorBenfical.maxDate,
          };
          /**
         * Method fetches data from the state
         */
          const businessState = useSelector((state: any) =>
                fetchDataFromState(state, 'customer-kyc-data')
            );

        /**
         * Method handles the dates validation for Date of Birth (DOB) field
         * @param value 
         * @param fieldName 
         */
        const handleOnChangeEventForDate = (value: any, fieldName: string) => {
            handleDateValidation(fieldName, value, setValue, setError, clearErrors, true, ageLimit(18),null,dobError);
            isNullOrUndefined(errors?.dob) && saveNodeData('ownership-info-page', 'dob', value, setValue, getValues,  dispatch, businessState, props?.index);
            
        }

        /**
         * Method handles the change event for the state dropdown field
         * @param e 
         * @param fieldName 
         */
        const handleStateOnChangeEvents = (e: any, fieldName: string) => {
            handleFieldChange('state', e, setValue, clearErrors);
            saveNodeData('ownership-info-page', fieldName, e, setValue, getValues,  dispatch, businessState, props?.index);
        }
                  
        return (
            <Grid container item id='signUp-business-owner' xs={12} >
                <FxCard id="signUp-business-owner-form-card" className="fx-info-kyc-edit">
                    <Grid xs={12} className="fx-form-edit-profile">
                        {businessOwnerDetails !== undefined && <form id="signUp-business-owner-form" onSubmit={handleSubmit(onSubmit)}>
                            <FxCardBody id="signUp-business-owner-form-card-body" className="fx-info-card" >
                                <Grid container item direction="row" spacing={2} className="fx-info-card-form" >
                                     <FxTextEdit register={{ ...register("id") }} className={"fx-hidden"} control={control} rules={{ required: false }} id="signUp-business-owner-form-card-first-name"  name="id" variant="outlined" defaultValue={businessOwnerDetails?.id} />
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("firstName") }} className={errors.firstName ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={{ required: true }} id="signUp-business-owner-form-card-first-name" label="Legal First Name" name="firstName" variant="outlined" defaultValue={businessOwnerDetails?.firstName} onBlur={(e) => saveNodeData('ownership-info-page', 'firstName', e, setValue, getValues,  dispatch, businessState, props?.index)} />
                                        <FieldErrorMessageRender error={errors} fieldKey='firstName' />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("lastName") }} className={errors.lastname ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={{ required: true }} id="signUp-business-owner-form-card-last-name" label="Legal Last Name" name="lastName" variant="outlined" defaultValue={businessOwnerDetails?.lastName} onBlur={(e) => saveNodeData('ownership-info-page', 'lastName', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("email") }} className={errors.email ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={setEmailValidationOptions} id="signUp-business-owner-form-card-email" label="Email" name="email" variant="outlined" defaultValue={businessOwnerDetails?.email } isEditable={(invitationType === 'EMAIL' && isAuthUser) ? false : true} onChange={(e: any) => { handleEmailChange(e, setValue, setError, clearErrors) }} onBlur={(e) => saveNodeData('ownership-info-page', 'email', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='email'/>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("jobtitle") }} className={errors.jobtitle ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={{ required: true }} id="signUp-business-owner-form-card-jobTitle" label="Job Title" name="jobtitle" defaultValue={businessOwnerDetails?.jobtitle}  onBlur={(e) => saveNodeData('ownership-info-page', 'jobtitle', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='jobtitle' />
                                    </Grid>
                                    <Grid item xs={12} sm={12} >
                                    <FxTextEdit register={{ ...register("ownerShipPercentage") }} className={errors.ownerShipPercentage ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={setOwnerShipPercentageRule} suffix="%" id="signUp-business-owner-form-card-ownerShipPercentage" type="number" label={"Ownership"} name="ownerShipPercentage" variant="outlined" defaultValue={businessOwnerDetails?.ownerShipPercentage} min='0' onBlur={(e) => saveNodeData('ownership-info-page', 'ownerShipPercentage', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='ownerShipPercentage' />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxLabelView id="business-owner-details-label" className="" >ABOUT OWNER</FxLabelView>
                                    </Grid>
                                    <Grid item sm={12} xs={12}>
                                        <FxDateEdit register={{ ...register("dob") }} className={errors.dob ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={{ required: true }} id="signUp-business-owner-form-card-dob" label="Date of Birth" name="dob" variant="outlined" value={businessOwnerDetails?.dob} maxDate={ageLimit(18)} setValue={setValue} defaultCalendarMonth={ageLimit(18)} onChange={(value) => handleOnChangeEventForDate(value, 'dob')} ageLimitMessage={dobError.maxDate} futureDateMessage={dobError.futureDate}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='dob' type='date' />
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={12}>
                                        <FxPhoneEdit register={register} className={errors.mobilePhone ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={setPhoneValidationOptions(true)} id="signUp-business-owner-form-card-mobilePhone" label="Mobile Number" name="mobilePhone" placeholder={'XXX-XXX-XXXX'} defaultValue={businessOwnerDetails?.mobilePhone} setValue={setValue} setError={setError} clearErrors={clearErrors} isEditable={(invitationType === "SMS" && isAuthUser) ? false : true} onBlur={(e) => saveNodeData('ownership-info-page', 'mobilePhone', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='mobilePhone' />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxMaterialSelect register={{ ...register("usCitizen") }} rules={{ required: true }} className={errors.usCitizen ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} id="signUp-business-owner-select-usCitizen" name="usCitizen" data={usCitizenDropdown} label="Is US Citizen" setValue={setValue} value={businessOwnerDetails?.usCitizen} defaultValue={businessOwnerDetails?.usCitizen} onChange={(e) => saveNodeData('ownership-info-page', 'usCitizen', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                    </Grid>
                                    

                                    {/*** Identification Info Fields ***/}
                                    <Grid container item xs={12} sm={12} display={'flex'} alignItems={'center'}>
                                        <Grid item >
                                            <FxLabelView id="business-owner-details-label" className="" >IDENTIFICATION INFO</FxLabelView>
                                        </Grid>
                                        <Grid item xs={1} container justifyContent="center" alignItems="center">
                                            {ShowInfoToolTip('fx-business-owner-title-tooltip', 'To keep your account secure, we need to verify some details. This helps us ensure a safe and compliant experience for you.', 'bottom-start')}
                                        </Grid>
                                    </Grid>

                                    <Grid item xs ={12} sm={12}>
                                        <FxMaterialSelect
                                            register={{ ...register("taxIdentifier") }}
                                            control={control}
                                            rules={{ required: false }}
                                            id="signUp-business-form-card-tax-identifier"
                                            name="taxIdentifier"
                                            data={taxIdentifierData}
                                            readOnly={Boolean((businessOwnerDetails?.ssn !== '' || businessOwnerDetails?.itin !== '') && businessOwnerDetails.id)}
                                            value={defaultTaxIdentifier}
                                            label="Identification Method"
                                            setValue={setValue}
                                        />
                                    </Grid>
                                    <Grid container item xs={12} sm={12} alignItems="center">
                                        <Grid item xs={isMobileScreen?11:12} sm={11}>
                                            <FxTextEditSSN
                                                key={taxIdentifier}
                                                register={{ ...register(taxIdentifier) }}
                                                className={errors.ssn || errors.itin ? "border-error-input fx-input-edit" : "fx-input-edit"}
                                                error={errors?.ssn || errors?.itin}
                                                control={control}
                                                rules={taxIdentifier === 'ssn' ? {...setSsnValidationOptions(true)} : {...setItinValidationOptions(true)}}
                                                id="signUp-business-form-card-ssn-itin"
                                                label={`${taxIdentifier === 'ssn' ? 'Social Security Number' : 'Individual Taxpayer Identification Number'}`}
                                                placeholder="XXX-XX-XXXX"
                                                name={taxIdentifier}
                                                variant="outlined"
                                                setValue={setValue}
                                                setError={setError}
                                                clearErrors={clearErrors}
                                                defaultValue={businessOwnerDetails?.ssn || businessOwnerDetails?.itin}
                                                onBlur={(e: any) =>
                                                    saveNodeData('ownership-info-page', taxIdentifier, e, setValue, getValues,  dispatch, businessState, props?.index)
                                                }
                                            />   
                                        </Grid>
                                        <Grid item xs={isMobileScreen?1:12} sm={1} container justifyContent="center" alignItems="center">
                                        {ShowInfoToolTip('fx-business-owner-title-tooltip', 'We will use tax identifier to verify your identity and will not check your credit score', 'bottom-end')}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={isMobileScreen ? 11 : 12} sm={11} className="fx-individual-details-error-row" >
                                        <FieldErrorMessageRender error={errors} fieldKey={taxIdentifier === 'ssn' ? 'ssn' : 'itin'} />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxLabelView id="business-owner-details-label" className="" >SECONDARY IDENTIFICATION</FxLabelView>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FxMaterialSelect register={{ ...register('secondaryIdentificationType') }} control={control} className={errors['secondaryIdentificationType'] ? "border-error-input fx-input-edit" : "fx-input-edit"} rules={{ required: true }} id={'secondaryIdentificationType'} name={'secondaryIdentificationType'} data={secondaryIDTypeData}
                                            onChange={(e)=>handleChange(e,'secondaryIdentificationType')} label="Type " setValue={setValue}  value={businessOwnerDetails?.secondaryIdentificationType}/>
                                            <FieldErrorMessageRender error={errors} fieldKey='secondaryIdentificationType' />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FxTextEdit register={{ ...register("secondaryIdentificationId") }} className={errors.secondaryIdentificationId ? "border-error-input fx-input-edit login-email fs-mask" : "fx-input-edit login-email fs-mask"} control={control} rules={secondaryIdentificationIdValidation(secondaryIdType)} id="signup-secondaryIdentificationId" label="ID " name="secondaryIdentificationId"defaultValue={businessOwnerDetails?.secondaryIdentificationId} onChange={(e: any) => { handleSecIdChange(e, setValue, setError, clearErrors, secondaryIdType) }} onBlur={(e) => saveNodeData('ownership-info-page', 'secondaryIdentificationId', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='secondaryIdentificationId' />
                                    </Grid>
                                    {secondaryIdType === 'DRIVER_LICENSE' &&
                                        <Grid item xs={12} sm={4}>
                                            <FxMaterialSelect register={{ ...register('secondaryIdentificationIssuanceState') }} control={control} className={errors['secondaryIdentificationIssuanceState'] ? "border-error-input fx-input-edit" : "fx-input-edit"} rules={{ required: true }} id={'secondaryIdentificationIssuanceState'} name={'secondaryIdentificationIssuanceState'} data={usa_state}
                                                onChange={(e)=>handleChange(e,'secondaryIdentificationIssuanceState')} label="State of Issuance " setValue={setValue} value={businessOwnerDetails?.secondaryIdentificationIssuanceState} />
                                                <FieldErrorMessageRender error={errors} fieldKey='secondaryIdentificationIssuanceState' />
                                        </Grid>}
                                    {secondaryIdType !== 'DRIVER_LICENSE' && secondaryIdType !== 'ALIEN_REGISTRATION_CARD' && <Grid item xs={12} sm={4}>
                                        <FxMaterialSelect register={{ ...register('secondaryIdentificationIssuance') }} control={control} className={errors['secondaryIdentificationIssuance'] ? "border-error-input fx-input-edit" : "fx-input-edit"} rules={{ required: secondaryIdType !== '' ? true : false }} id={'secondaryIdentificationIssuance'} name={'secondaryIdentificationIssuance'} data={issuance_countries} value={businessOwnerDetails?.secondaryIdentificationIssuance} 
                                            onChange={(e)=>handleChange(e,'secondaryIdentificationIssuance')} readOnly={secondaryIdType === 'ALIEN_REGISTRATION_CARD' ? true : false} label="Country of Issuance " setValue={setValue} />
                                             <FieldErrorMessageRender error={errors} fieldKey='secondaryIdentificationIssuance' />
                                    </Grid>}
                                    {secondaryIdType === 'ALIEN_REGISTRATION_CARD' &&
                                        <Grid item xs={12} sm={4}>
                                            <FxTextEdit register={{ ...register("secondaryIdentificationIssuanceAlien") }} className={errors.secondaryIdentificationIssuanceAlien ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"}
                                                control={control} id="signUp-business-owner-secondaryIdentificationIssuanceAlien" label="Country of Issuance " name="secondaryIdentificationIssuanceAlien" defaultValue="US" isEditable={false} />
                                            <FieldErrorMessageRender error={errors} fieldKey='secondaryIdentificationIssuanceAlien' />
                                        </Grid>
                                    }
                                    <Grid item xs={12} sm={12}>
                                        <FxLabelView id="business-owner-details-label" className="" >PRIMARY ADDRESS</FxLabelView>
                                    </Grid>
                                    <FxTextEdit register={{ ...register("address_id") }} className={"fx-hidden"} control={control} rules={{ required: false }} id="signUp-business-owner-form-card-first-name"  name="address_id" variant="outlined" defaultValue={businessOwnerDetails?.address_id} />
                                    <Grid item xs={12} sm={6}>
                                        <FxTextEdit register={{ ...register("addressLine1") }} className={errors.addressLine1 ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={setAddressLine1Validation(true)}  id="signUp-business-owner-addressLine1" label="Address Line 1" name="addressLine1" defaultValue={businessOwnerDetails?.addressLine1}   onChange={(e: any) => { handleAddressChange(e, setValue, setError, clearErrors) }} onBlur={(e) => saveNodeData('ownership-info-page', 'addressLine1', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='addressLine1' />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FxTextEdit register={{ ...register("addressLine2") }} className={errors.addressLine2 ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={{ required: false }} id="signUp-business-owner-addressLine2" label="Address Line 2 (optional)" name="addressLine2" defaultValue={businessOwnerDetails?.addressLine2} onBlur={(e) => saveNodeData('ownership-info-page', 'addressLine2', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("city") }} className={errors.city ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={setCityValidation(true)}  id="signUp-business-owner-city" label="City" name="city" defaultValue={businessOwnerDetails?.city} onBlur={(e) => saveNodeData('ownership-info-page', 'city', e, setValue, getValues,  dispatch, businessState, props?.index)} />
                                        <FieldErrorMessageRender error={errors} fieldKey='city' />
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        <FxMaterialSelect register={{ ...register("state") }} rules={{ required: true }} className={errors.state ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} id="signUp-business-owner-select-state" name="state" data={usa_state} label="State" setValue={setValue} value={businessOwnerDetails?.state} onChange={(e) => handleStateOnChangeEvents(e, 'state')}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='state' />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FxTextEdit register={{ ...register("zip") }} className={errors.zip ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={setZipValidationOptions(true)} id="signUp-business-owner-zip" label="Zip" name="zip" defaultValue={businessOwnerDetails?.zip} onChange={(e: any) => { handleZipChange(e, setValue, setError, clearErrors) }} onKeyDown={(e: any) => { handleKeyDownChange(e, setValue) }} onBlur={(e) => saveNodeData('ownership-info-page', 'zip', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='zip' />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxRadioEdit register={{ ...register("authSignatory") }} control={control} className={errors.authSignatory ? "border-error-input fx-input-edit kyc-radio-edit" : "fx-input-edit kyc-radio-edit"} data={setAsAuthSignatoryRadioButtonData} id="signUp-business-owner-form-card-authSignatory" label="Do you have substantial control over company's finances and will act as authorized signatory for the account?" name="authSignatory" row="horizontal" setValue={setValue} onChange={handleSetAsAuthSignatoryRadioButtonChange} defaultValue={businessOwnerDetails?.authSignatory === true || businessOwnerDetails?.authSignatory === 'yes' || businessOwnerDetails?.authSignatory === 'true' ? 'yes' : 'no'}/>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                      <Divider />
                                    </Grid>
                                </Grid>
                            </FxCardBody>
                            <FxCardFooter id="signUp-business-owner-Card-Footer" className="fx-footer">
                                <Grid container item direction="row" justifyContent="flex-end" className="fx-modal-footer">
                                    <FxButton
                                        disableRipple={false}
                                        variant="contained"
                                        className="fx-button fx-button-cancel"
                                        id="back-edit-business-owner-btn"
                                        onClick={handleGoBackClick}
                                    > CANCEL
                                    </FxButton>
                                    <Grid className='fx-padding-right-15'></Grid>
                                    <FxButton
                                        disableRipple={false}
                                        className="fx-button fx-button-theme"
                                        id="save-edit-business-owner-btn"
                                        type="submit"
                                        isSubmitting={isSubmitting}
                                    > SAVE
                                    </FxButton>
                                </Grid>
                            </FxCardFooter>
                        </form>}
                    </Grid>
                </FxCard>
            </Grid>
        )
    }
)
